import waseminari from "../assets/waseminari.png";
import visigalogo from "../assets/visigalogo.png";
import hailmary from "../assets/hailmary.png";
import jesus from "../assets/jesus.png";
import hailmary3 from "../assets/hailmary3.png";

const FormationAdmission = () => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0  dark:bg-gray-800">

            {/* First Portion (3 grid) */}
            <div className="lg:col-span-3 bg-gray-100 dark:bg-gray-800 p-4 flex flex-col items-center">
                <h1 className="text-3xl sm:text-xl lg:text-2xl text-center tracking-wide text-gray-900 dark:text-white">
                    St Mary's Junior Seminary{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
                        (Visiga Seminary)
                    </span>
                </h1>
                <img src={visigalogo} alt="Visiga Seminary Logo" className="mt-4 w-32 h-auto" />
            </div>

            {/* Middle Portion (Main Content) */}
            <div className="lg:col-span-6 flex flex-col items-start text-left mt-1 lg:mt-5">
                <h1 className="text-2xl sm:text-2xl lg:text-2xl tracking-wide text-gray-900 dark:text-white">
                    Conditions for Admission to{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
                        Visiga Seminary for Formation
                    </span>
                </h1>

                <div className="text-sm mt-4 text-gray-800 dark:text-gray-200">
                    <ul className="list-disc pl-5 space-y-2">
                        <li>
                            <strong>Be a Young Catholic Man</strong> – Only male students who are practicing Catholics are eligible for admission.
                        </li>
                        <li>
                            <strong>Completion of Primary Education</strong> – All applicants must have completed seven years of primary education (Grade 7).
                        </li>
                        <li>
                            <strong>Pass the Entrance Examination</strong> – Candidates must successfully complete the required entrance exams, including:
                            <ul className="list-disc pl-5 mt-1">
                                <li>Religion Exam</li>
                                <li>Oral Exam</li>
                                <li>Written Exam</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <h1 className="mt-6 text-2xl tracking-wide text-gray-900 dark:text-white">
                    Admission Forms of{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
                        Visiga Seminary
                    </span>
                </h1>

                <br />

                <p className="mt-4 text-sm text-gray-800 dark:text-gray-200 w-full">

                The form must be filled out by parents, community leaders, and the parish priest before being submitted for further processing. It is important that the form is completed and submitted on or before the due date. Please ensure all required details are provided clearly.
                <br />
                <br />
                <br />
                    Forms are available at the following places:
                </p>

                <div className="flex flex-col items-start mt-2 lg:mt-5 text-sm text-left text-gray-800 dark:text-gray-200">
                    <ul className="list-disc pl-5 space-y-1">
                        <li><strong>St Mary's Junior Seminary</strong></li>
                        <li><strong>Msimbazi Centre</strong></li>
                        <li><strong>St Joseph</strong></li>
                    </ul>

                    <p className="mt-2">
                        Price of each form: <strong>15,000 Tsh</strong>
                    </p>
                </div>
            </div>

            {/* Third Portion (3 grid) */}
            <div className="lg:col-span-3 bg-gray-100 dark:bg-gray-800 p-4 flex flex-col items-center">
                {/* Images arranged in a column */}
                <img src={hailmary3} alt="Hail Mary 3" className="mt-4 w-50 h-60" />
            </div>
        </div>
    );
};

export default FormationAdmission;
